import { render, staticRenderFns } from "./Gaines2.vue?vue&type=template&id=2b72d9e8&scoped=true"
import script from "./Gaines2.vue?vue&type=script&lang=ts"
export * from "./Gaines2.vue?vue&type=script&lang=ts"
import style0 from "./Gaines2.vue?vue&type=style&index=0&id=2b72d9e8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b72d9e8",
  null
  
)

export default component.exports